import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPrintedLabel = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M43 8H15c-3.9 0-7 3.1-7 7v34c0 3.9 3.1 7 7 7h34c3.9 0 7-3.1 7-7V21L43 8Z",
			stroke: "currentColor",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43 8v9c0 2.2 1.8 4 4 4h9",
			stroke: "currentColor",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 17,
			y: 20,
			width: 16,
			height: 7,
			rx: 1,
			stroke: "currentColor",
			strokeWidth: 2.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17 36h29M17 44h29",
			stroke: "currentColor",
			strokeWidth: 2.5,
			strokeLinecap: "round"
		})
	]
});
export default SvgPrintedLabel;
